<template>
  <div>
    <!-- <b-button size="sm" variant="outline-success" :to="{ name: 'admin-user' }">
      Voltar
    </b-button> -->

    <b-card>
      <b-tabs>
        <b-tab title="Siglas">
          <b-form class="custom-form" @submit.prevent>
            
            <b-row>
              <!-- <b-col md="12">
                <div class="form-label-group">
                  <b-form-input id="id" placeholder="ID" v-model="form._id" disabled />
                  <label for="id">ID</label>
                </div>
              </b-col> -->
              <b-col md="6">
                <div class="form-label-group">
                  <label for="origin-list">Serviços</label>
                  <b-form-group label="Serviços" label-for="origin-list">
                  <v-select
                    id="origin-list"
                    v-model="form.service"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="name"
                    :options="publisherServices"
                    :reduce="option => option.id"
                  >
                    <span slot="no-options">{{$t('GENERAL.NoOptions')}}</span>
                  </v-select>
                </b-form-group>
                </div>
              </b-col>
              <b-col md="6"></b-col>
              <b-col md="6">
                <div class="form-label-group flex">
                  <b-form-input id="note" placeholder="Descrição" v-model="form.note"/>
                  <label for="note">Descrição</label>
                </div>
              </b-col>
              <b-col md="6" v-if="form.service == 'publisher-acceptor'">
                <div class="form-label-group flex">
                  <b-form-input id="domain" placeholder="Domain" v-model="form.domain"/>
                  <label for="domain">Acceptor Domain</label>
                </div>
              </b-col>
              <b-col md="12"></b-col>
              <b-col md="4">
                <div class="form-label-group flex">
                  <b-form-input id="api_key" placeholder="API KEY" v-model="form.api_key" disabled/>
                  <label for="api_key">API KEY</label>
                </div>
              </b-col>
                  
              <b-col md="1">
                <b-button variant="flat-primary" class="btn-icon rounded-circle" @click="onCopy" v-if="form.api_key">
                  <feather-icon icon="ClipboardIcon" />
                </b-button>
              </b-col>
              <b-col md="2">
                <b-button type="submit" variant="primary" class="mr-1" @click="generateNewToken">Gerar API Key</b-button>
              </b-col>


              <template v-if="form.service == 'publisher-geolocation'">
                <b-col class="mb-2" md="12"><hr /></b-col>
                <b-col class="mb-2" md="12"><h2>Regras para geolocalização</h2></b-col>
                <b-col md="4">
                  <div class="form-label-group flex">
                    <b-form-input id="distanceGreaterThanKm" v-model="form.geolocation_rules.distanceGreaterThanKm"/>
                    <label for="distanceGreaterThanKm">Distância maior que KM</label>
                  </div>
                </b-col>
                <b-col md="4">
                  <div class="form-label-group flex">
                    <b-form-input id="speedToDetermineImpossibleTravelKmh" v-model="form.geolocation_rules.speedToDetermineImpossibleTravelKmh"/>
                    <label for="speedToDetermineImpossibleTravelKmh">Velocidade para determinar viagem impossivel em KM</label>
                  </div>
                </b-col>
                <b-col md="12"></b-col>
                <b-col md="3">
                  <div class="form-label-group">
                    <b-form-group label="Nome do país diferente" label-for="countryNameDifferent">
                      <v-select id="countryNameDifferent" v-model="form.countryNameDifferent" label="name" :options="dropdownBool" :reduce="option => option.value">
                        <span slot="no-options">{{$t('GENERAL.NoOptions')}}</span>
                      </v-select>
                    </b-form-group>
                  </div>
                </b-col>
                <b-col md="3">
                  <div class="form-label-group">
                    <b-form-group label="Nome da região diferente" label-for="regionNameDifferent">
                      <v-select v-model="form.regionNameDifferent" label="name" :options="dropdownBool" :reduce="option => option.value">
                        <span slot="no-options">{{$t('GENERAL.NoOptions')}}</span>
                      </v-select>
                    </b-form-group>
                  </div>
                </b-col>
                <b-col md="3">
                  <div class="form-label-group">
                    <b-form-group label="Nome da cidade diferente" label-for="cityNameDifferent">
                      <v-select v-model="form.cityNameDifferent" label="name" :options="dropdownBool" :reduce="option => option.value">
                        <span slot="no-options">{{$t('GENERAL.NoOptions')}}</span>
                      </v-select>
                    </b-form-group>
                  </div>
                </b-col>
                <b-col md="12"></b-col>
                <b-col md="3">
                  <div class="form-label-group">
                    <b-form-group label="Timezone diferente" label-for="timeZoneDifferent">
                      <v-select v-model="form.timeZoneDifferent" label="name" :options="dropdownBool" :reduce="option => option.value">
                        <span slot="no-options">{{$t('GENERAL.NoOptions')}}</span>
                      </v-select>
                    </b-form-group>
                  </div>
                </b-col>
                <b-col md="3">
                  <div class="form-label-group">
                    <b-form-group label="Verificar conexão com VPN" label-for="isVpnConnection">
                      <v-select v-model="form.isVpnConnection" label="name" :options="dropdownBool" :reduce="option => option.value">
                        <span slot="no-options">{{$t('GENERAL.NoOptions')}}</span>
                      </v-select>
                    </b-form-group>
                  </div>
                </b-col>
                <b-col md="3">
                  <div class="form-label-group">
                    <b-form-group label="Verificar ip em lista bloqueado" label-for="isIpBlockedList">
                      <v-select v-model="form.isIpBlockedList" label="name" :options="dropdownBool" :reduce="option => option.value">
                        <span slot="no-options">{{$t('GENERAL.NoOptions')}}</span>
                      </v-select>
                    </b-form-group>
                  </div>
                </b-col>
              </template>


              <b-col class="mb-2" md="12"><hr /></b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input
                    id="dt-created"
                    placeholder="Data Criação"
                    v-model="form.dt_create"
                    disabled
                  />
                  <label for="dt-created">Data Criação</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input
                    id="email-created"
                    placeholder="Email Criação"
                    v-model="form.email_create"
                    disabled
                  />
                  <label for="email-created">Email Criação</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input
                    id="dt-update"
                    placeholder="Data Alteração"
                    v-model="form.dt_update"
                    disabled
                  />
                  <label for="dt-update">Data Alteração</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input
                    id="email-update"
                    placeholder="Email Alteração"
                    v-model="form.email_update"
                    disabled
                  />
                  <label for="email-update">Email Alteração</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input
                    id="dt-delete"
                    placeholder="Data Desativação"
                    v-model="form.dt_delete"
                    disabled
                  />
                  <label for="dt-delete">Data Desativação</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input
                    id="email-delete"
                    placeholder="Email Desativação"
                    v-model="form.email_delete"
                    disabled
                  />
                  <label for="email-delete">Email Desativação</label>
                </div>
              </b-col>

              <b-col cols="12">
                <b-form-group>
                  <b-form-checkbox id="active" name="active" checked="true" v-model="form.active">
                    Ativo
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
              <b-col>
                <b-button type="submit" variant="primary" class="mr-1" @click="onSubmit">
                  Enviar
                </b-button>
                <b-button
                  variant="danger"
                  class="mr-1"
                  @click="onBackPage"
                >
                  Voltar
                </b-button>
              </b-col>
            </b-row>
          </b-form>
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  BForm,
  BButton,
  BTabs,
  BTab,
  BCard,
} from "bootstrap-vue";
import serviceAccessManagerService from "@/providers/serviceAccessManagerService";
import convertDatetimeHelper from '@/helpers/convert-datetime-helper';
import messagesNotifyHelper from '@/helpers/messages-notify-helper';
import AppConstants from '@/appConstants';
import dropdownService from '@/providers/dropdownService';
import vSelect from "vue-select";

export default {
  props: {},
  data() {
    return {
      dataID: null,
      publisherServices: [],
      dropdownBool: [{value: true, name: 'Sim'}, {value: false, name: 'Não'}],
      form: {
        _id: "",
        service: "",
        api_key: "",
        note: "",
        active: true,
        geolocation_rules: {
          distanceGreaterThanKm: null,
          speedToDetermineImpossibleTravelKmh: null,
          countryNameDifferent: null,
          regionNameDifferent: null,
          cityNameDifferent: null,
          timeZoneDifferent: null,
          isVpnConnection: null,
          isIpBlockedList: null
        },
        domain: "",
        dt_create: "",
        dt_update: "",
        dt_delete: "",
        email_create: "",
        email_update: "",
        email_delete: "",
      },
    };
  },
  created() {
    this.$store.dispatch("admin/updatePageTitle", 'Novo acesso de serviço');
    if (this.isUpdate) {
      this.dataID = this.$route.params.id;
      // console.log("dataid: ", this.dataID);
    }

    this.loadData();
  },
  watch: {
    "form.name"(val) {
      if (val) {
        this.$store.dispatch("admin/updatePageTitle", val);
      } else {
        this.$store.dispatch("admin/updatePageTitle", 'Novo acesso de serviço');
      }
    },
  },
  computed: {
    isUpdate() {
      if (this.$route.params.id) {
        return true;
      }
      return false;
    },
  },
  methods: {
    onCopy() {
      this.$copyText(this.form.api_key).then(() => {
        messagesNotifyHelper.successNotify("Cópia", "API Key copiado");
      });
    },
    generateNewToken() {
      serviceAccessManagerService
        .generateNewToken(new URLSearchParams())
        .then((res) => {
          this.form.api_key = res.api_key;
          messagesNotifyHelper.successNotify('', 'Token gerado com sucesso')
        })
        .catch((err) => console.log(err));
    },
    onBackPage() {
      this.$router.push(AppConstants.NAVIGATION_PAGE_ADM_SERVICE_ACCESS_MANAGER);
    },
    onSubmit() {
      serviceAccessManagerService
        .register(this.form, new URLSearchParams())
        .then(() => {
          // console.log(res);
          if (this.isUpdate) {
            messagesNotifyHelper.updatedRecordNotify();
          } else {
            messagesNotifyHelper.createdRecordNotify();
            this.onBackPage();
          }
        })
        .catch((err) => console.log(err));
    },
    getDetails() {
      const params = new URLSearchParams();
      serviceAccessManagerService
        .getDetails(this.dataID, params)
        .then((res) => {
          // console.log(res);
          this.form._id = res._id;
          this.form.service = res.service;
          this.form.api_key = res.api_key;
          this.form.domain = res.domain;
          this.form.note = res.note;
          if (res.geolocation_rules) {
            this.form.geolocation_rules.distanceGreaterThanKm = res.geolocation_rules.distanceGreaterThanKm;
            this.form.geolocation_rules.speedToDetermineImpossibleTravelKmh = res.geolocation_rules.speedToDetermineImpossibleTravelKmh;
            this.form.geolocation_rules.countryNameDifferent = res.geolocation_rules.countryNameDifferent;
            this.form.geolocation_rules.regionNameDifferent = res.geolocation_rules.regionNameDifferent;
            this.form.geolocation_rules.cityNameDifferent = res.geolocation_rules.cityNameDifferent;
            this.form.geolocation_rules.timeZoneDifferent = res.geolocation_rules.timeZoneDifferent;
            this.form.geolocation_rules.isVpnConnection = res.geolocation_rules.isVpnConnection;
            this.form.geolocation_rules.isIpBlockedList = res.geolocation_rules.isIpBlockedList;
          }
          
          this.form.active = res.active;
          this.form.dt_create = convertDatetimeHelper.convertStringToDateTime(res.dt_create);
          this.form.dt_update = res.dt_update ? convertDatetimeHelper.convertStringToDateTime(res.dt_update) : res.dt_update;
          this.form.dt_delete = res.dt_delete ? convertDatetimeHelper.convertStringToDateTime(res.dt_delete) : res.dt_delete;
          this.form.email_create = res.email_create;
          this.form.email_update = res.email_update;
          this.form.email_delete = res.email_delete;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    loadData() {
      if (this.isUpdate) {
        this.getDetails();
      }
      dropdownService
        .getPublisherServices(new URLSearchParams())
        .then((res) => {
          this.publisherServices = res;
        })
        .catch((err) => console.log(err));
    },
  },
  components: {
    vSelect,
    BButton,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BForm,
    BTabs,
    BTab,
    BCard,
  },
};
</script>

<style lang="scss">
.subject-badge-select {
  margin-bottom: 10px;
  .badge {
    margin: 0px 5px;
  }
}
</style>